import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function nonNegativeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isValid = control.value >= 0;
        return isValid ? null : { nonNegative: true };
    };
}
